/**
 * Application Configuration
 * Centralized configuration from environment variables
 */

export const config = {
  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  },

  // App Configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'SwaraPoint Web',
    version: import.meta.env.VITE_APP_VERSION || '0.0.0',
  },

  // Feature Flags
  features: {
    analytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    debug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    useMockData: import.meta.env.VITE_USE_MOCK_DATA !== 'false', // Default: true (use mock data)
  },

  // Sentry Configuration
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    environment: import.meta.env.VITE_ENV || 'development',
  },

  // Environment
  env: {
    current: import.meta.env.VITE_ENV || 'development',
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    mode: import.meta.env.MODE,
  },
} as const

// Log configuration in development
if (config.env.isDevelopment && config.features.debug) {
  console.log('🔧 App Configuration:', config)
}

export default config

